import React, { useMemo } from 'react';
import './_pages.table.scss'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { isNull, truncate } from 'lodash';
import { useHistory } from 'react-router-dom';
import FormSwitch from '../../../../../../components/FormSwitch';
import { routesAppearance } from '../../../../helpers';

const Body = ({ isLoading, items, config, onChangeVisibility }) => {
  const history = useHistory();
  const routeEditPage = useMemo(() => routesAppearance.find((route) => route.code === 'edit-page'), [])

  const onEditPage = (pageId) => {
    if (pageId) {
      history.push({
        pathname: routeEditPage.link,
        search: `?id=${pageId}`,
      })
    }
  }

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
    >
      {items.map((page) => {
        const visibilityChecked = !!(page.visibility || isNull(page.visibility))
        const visibilityDisabled = !config?.access?.pages_toggle_visibility || !page?.access?.toggle;
        const updatedSplit = page.updated.split(' ');
        const firstDate = updatedSplit[0];
        const secondDate = updatedSplit[1];
        return (
          <tr
            key={`page-${page.id}`}
            className={classNames({
              grey: !page.visibility,
            })}
          >
            <td className="p-l pages-table__name">
              {truncate(page.name, {
                length: 100,
                omission: '...',
              })}
            </td>
            <td className="pages-table__visibility">
              <FormSwitch
                onChange={() => onChangeVisibility(page.id, !page.visibility)}
                disabled={visibilityDisabled}
                checked={visibilityChecked}
              />
            </td>
            <td>{page.is_public ? 'Yes' : 'No'}</td>
            <td className="pages-table__updated">
              <span>{firstDate}</span>
              {' '}
              {secondDate ? <span>{secondDate}</span> : null }
            </td>
            {config?.access?.pages_edit && page?.access?.edit
              ? (
                <td className="p-r text-right">
                  <Button onClick={() => onEditPage(page.id)} bsSize="xsmall">Edit</Button>
                </td>
              ) : null}
          </tr>
        )
      })}
    </tbody>
  );
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
  onChangeVisibility: PropTypes.func,
};

export default Body;
